import css from '../../../utils/css';

export default css`
  :host {
    /* bookmaker logo is not clickable */
    [class*='BookmakerClickOutContainer'] {
      pointer-events: none;
    }

    /* Hide 'BET' label on desktop gird cell hover */
    [class*='OddsCellBtn']:hover:after {
      display: none;
    }

    /* Hide Best odds patch for mobile */
    [class*='OddsRow'] [class*='bestOddsStyles'] {
      display: none;
    }
  }
`;
